import type { SxProps, Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

/** Raised section container (KPI blocks, chart groups). */
export const dashboardSectionPaperSx: SxProps<Theme> = {
  p: { xs: 2, sm: 3 },
  mb: 3,
  borderRadius: '16px',
  bgcolor: 'background.paper',
  border: 1,
  borderColor: 'divider',
  boxShadow: 1,
};

/** Metric / stat card grid inside a section. */
export const dashboardMetricGridSx: SxProps<Theme> = {
  display: 'grid',
  gap: 2.5,
  alignItems: 'stretch',
};

/** Nested metric card — sits inside a section paper. */
export const dashboardInsetCardSx = (theme: Theme) => ({
  p: 2.5,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '12px',
  bgcolor: alpha(theme.palette.text.primary, 0.02),
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: 'none',
  transition: 'border-color 0.2s ease, background-color 0.2s ease',
  '&:hover': {
    bgcolor: alpha(theme.palette.primary.main, 0.03),
    borderColor: alpha(theme.palette.primary.main, 0.18),
  },
});

/** Chart / visualization card shell. */
export const dashboardChartCardSx = (theme: Theme) => ({
  p: 2.5,
  borderRadius: '12px',
  bgcolor: alpha(theme.palette.text.primary, 0.02),
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: 'none',
  transition: 'border-color 0.2s ease',
  '&:hover': {
    borderColor: alpha(theme.palette.primary.main, 0.15),
  },
});
